import { createContext } from "react";
import type { Subscription } from "../../../api/subscriptions";
import type { SubscriptionTier } from "../../../api/tiers";

export interface SubscriptionsContextType {
  subscriptions: Subscription[];
  tiers: SubscriptionTier[];
  loading: boolean;
  error: string | null;
  createSubscription: (data: {
    name: string;
    spots?: number;
    isCombo?: boolean;
  }) => Promise<Subscription | null>;
  updateSubscription: (
    id: string,
    data: {
      name?: string;
      spots?: number;
      isCombo?: boolean;
      isActive?: boolean;
    },
  ) => Promise<void>;
  deleteSubscription: (id: string) => Promise<void>;
  refetch: () => Promise<void>;
  createTier: (data: {
    subscriptionId: string;
    name: string;
    price: number;
    oldCsaMemberPrice: number;
    spots?: number;
    dependsOn?: string;
    takesFrom?: string[];
  }) => Promise<SubscriptionTier | null>;
  updateTier: (
    id: string,
    data: {
      name?: string;
      price?: number;
      oldCsaMemberPrice?: number;
      spots?: number;
      dependsOn?: string | null;
      takesFrom?: string[] | null;
    },
  ) => Promise<void>;
  refetchTiers: () => Promise<void>;
  deleteTier: (id: string) => Promise<void>;
}

export const SubscriptionsContext = createContext<SubscriptionsContextType>({
  subscriptions: [],
  tiers: [],
  loading: false,
  error: null,
  createSubscription: async () => null,
  updateSubscription: async () => {},
   deleteSubscription: async () => {},
  refetch: async () => {},
  createTier: async () => null,
  updateTier: async () => {},
  refetchTiers: async () => {},
  deleteTier: async () => {},
});
